import { useMutation } from '@apollo/client';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useEffect } from 'react';
import config from '../../../utils/config';
import { CheckmarkBox, DownloadButton, QrCodeWrapper } from '../../../components/FormInfo/BookingOrder/styled';
import { FORM_INFO_COMPONENT_TYPES, FORM_INFO_TYPES } from '../../../components/FormInfo/types';
import { vars } from '../../../reactive';
import { isAndroid, isiOS, replaceVariables } from '../../../utils';
import { SubmitFormsAnswers } from '../../../utils/queries';
import Checkmark from '../../../images/checkmark.svg';
import { CenteredInfoContainer } from '../../../components/FormInfo/styled';
import FormInfoFormsFilled from '../../../components/FormInfo/FormsFilled/FormInfo';

const FormsFilled = () => {
  const type = FORM_INFO_TYPES.FORMS_FILLED;

  const formsAnswers = vars.formsAnswers();
  const { title, body } = FORM_INFO_COMPONENT_TYPES[type];

  const [submitForms, { loading: loadingFormsSubmit, error: errorFormsToSubmit, data: dataFormsToSubmit }] = useMutation(SubmitFormsAnswers);

  const submitedFromsIds = [...new Set(formsAnswers?.map(form => form.formId))];

  const formsToSubmit = submitedFromsIds.map(formId => {
    const filteredFormAnswers = formsAnswers?.filter(form => form.formId === formId);
    return {
      FormId: formId,
      OrderId: null,
      answers: filteredFormAnswers.flatMap(form => {
        const questionId = form.questionId;
        const answers = filteredFormAnswers.filter(form => form.questionId === questionId).flatMap(form => form.answers);
        const answersToSubmit = answers.map(answer => ({
          ...answer,
          QuestionId: questionId
        }));
        return answersToSubmit;
      })
    };
  });

  useEffect(() => {
    if (formsToSubmit?.length && !dataFormsToSubmit && !errorFormsToSubmit && !loadingFormsSubmit) {
      submitForms({ variables: { submitFormsAnswersInput: { submitFormsAnswers: formsToSubmit } } }).finally(() => {
        vars.newOrders(null);
        vars.formsAnswers([]);
        vars.newOrders([]);
        vars.selectedForms([]);
      });
    }
  }, []);

  const isDeviceiOS = isiOS();
  const isDeviceAndroid = isAndroid();

  return (
    <FormInfoFormsFilled
      error={!!errorFormsToSubmit}
      type={type}
      loading={loadingFormsSubmit}
      title={title}
      body={replaceVariables(body, {
        downloadMethod: !isDeviceAndroid && !isDeviceiOS ? ' by scanning the QR code below with your phone’s camera.' : ''
      })}
      aboveTitleElement={
        <CenteredInfoContainer>
          <CheckmarkBox>
            <Checkmark />
          </CheckmarkBox>
        </CenteredInfoContainer>
      }
    >
      {isDeviceiOS || isDeviceAndroid ? (
        <DownloadButton target="_blank" href={isDeviceiOS ? config.APP_IOS_URL : config.APP_ANDROID_URL}>
          Download
        </DownloadButton>
      ) : (
        <QrCodeWrapper>
          <StaticImage src="../../../images/qrCode.png" alt="Qr code" quality={100} loading="eager" formats={['webp']} />
        </QrCodeWrapper>
      )}
    </FormInfoFormsFilled>
  );
};

export default FormsFilled;
